/**
 * Status and type cards at the top of a list are the filter: click a card to
 * filter to it, click the same card again to clear. Returns the next filter
 * value given the current one and the card that was clicked.
 */
export function toggleCardFilter<T>(current: T, clicked: T, cleared: T): T {
  return current === clicked ? cleared : clicked;
}
